import React, { useState, useEffect, Fragment } from "react";
import Select from "react-select";
import {
  Row,
  Col,
  Container,
  Label,
  Button,
  FormGroup,
  ButtonGroup,
} from "reactstrap";
import ApiCaller from "../../../../api/apiCaller";
import CityPicker from "../../../../components/CityPicker";
import CreateZoneModal from "./components/CreateZoneModal";

import "./index.css";
import t from "utils/Lang";

export default function ZoneElement() {
  const [users, setUsers] = useState([]);
  const [displayTab, setDisplayTab] = useState("zone_settings");
  const [zones, setZones] = useState([]);
  const [selectedZone, setSelectedZone] = useState<any>({});
  const [selectedZoneElement, setSelectedZoneElement] = useState<any>({});
  const [zoneElements, setZoneElements] = useState<Array<any>>([]);
  const [userZoneAssignment, setUserZoneAssignment] = useState<Array<any>>([]);
  const [showCreateZoneModal, setShowCreateZoneModal] =
    useState<Boolean>(false);
  const [zoneModalMode, setZoneModalMode] = useState<string>("create");

  const onZoneSelectionChange = async (selectedOptions: any) => {
    const res = await ApiCaller.get(`zone/${selectedOptions.zone.id}`);
    if (res?.result) {
      const zoneResult = res?.result;
      // This is for the select box
      zoneResult.label = zoneResult.name;
      zoneResult.value = zoneResult.id;
      zoneResult.zone = res?.result;

      setSelectedZone(zoneResult);
      setZoneElements(zoneResult.zone_elements || []);
      setUserZoneAssignment(
        zoneResult.user_assignments?.map((user: any) => ({
          value: user.id,
          label: `${user.first_name} ${user.last_name}`,
        })) || []
      );
    }
  };

  const addZoneElement = () => {
    const requiredZoneLevel = selectedZone?.zone?.zone_level;
    const newZoneElements = [...zoneElements];

    if (requiredZoneLevel === "city") {
      if (selectedZoneElement.city)
        newZoneElements.push(selectedZoneElement.city);
    }
    if (requiredZoneLevel === "district") {
      if (selectedZoneElement.district)
        newZoneElements.push(selectedZoneElement.district);
    }
    if (requiredZoneLevel === "ward") {
      if (selectedZoneElement.ward)
        newZoneElements.push(selectedZoneElement.ward);
    }
    setZoneElements(newZoneElements);
  };

  const removeZoneElement = (inputZoneElement: any) => {
    let newZoneElements = [...zoneElements];
    newZoneElements = newZoneElements.filter(
      (zoneElement: any) => zoneElement.id !== inputZoneElement.id
    );
    setZoneElements(newZoneElements);
  };

  const toogleCreateZoneModal = () => {
    setSelectedZone({});
    setShowCreateZoneModal(!showCreateZoneModal);
    setZoneModalMode("create");
  };

  const addUserToZone = (selectedUsers: any) => {
    setUserZoneAssignment(selectedUsers);
  };

  const getZones = async () => {
    const res = await ApiCaller.get("zone/");
    if (res?.result) {
      const normalizedZones: any = [];
      res.result.forEach((zone: any) => {
        normalizedZones.push({ label: zone.name, value: zone.id, zone });
      });
      setZones(normalizedZones);
    }
  };

  const saveZoneElement = async () => {
    const bodyToSubmit = {
      id: selectedZone.zone.id,
      zone_level: selectedZone.zone.zone_level,
      zone_elements: zoneElements,
    };
    const res = await ApiCaller.post(
      `zone/${bodyToSubmit.id}/element`,
      bodyToSubmit
    );
    if (res?.status === "ok") {
      alert("Đã cập nhật");
    } else {
      alert(res.message);
    }
  };

  const saveZoneAssignment = async () => {
    const bodyToSubmit = {
      user_assignments: userZoneAssignment
        ? userZoneAssignment.map((user) => ({
            id: user.value,
            name: user.label,
          }))
        : [],
    };
    const res = await ApiCaller.post(
      `zone/${selectedZone.id}/assignment`,
      bodyToSubmit
    );
    if (res?.status === "ok") {
      alert("Đã cập nhật");
    } else {
      alert(res.message);
    }
  };

  const getUsers = async () => {
    const res = await ApiCaller.get("user/current_brand");
    if (res.result) {
      const normalizedUsers = res.result.map((user: any) => {
        return {
          value: user.id,
          label: `${user.first_name} ${user.last_name}`,
        };
      });
      setUsers(normalizedUsers);
    }
  };

  const onZoneSave = (res: any) => {
    getZones();
    setShowCreateZoneModal(false);
    if (res?.isDelete) {
      setSelectedZone({});
    } else if (zoneModalMode == "edit") {
      onZoneSelectionChange({ zone: { id: selectedZone.id } });
    }
  };

  useEffect(() => {
    getZones();
    getUsers();
  }, []);

  const cityElementToShow = [];
  const requiredZoneLevel = selectedZone?.zone?.zone_level || "city";

  if (requiredZoneLevel === "city") {
    cityElementToShow.push("city");
  } else if (requiredZoneLevel === "district") {
    cityElementToShow.push("city");
    cityElementToShow.push("district");
  } else if (requiredZoneLevel === "ward") {
    cityElementToShow.push("city");
    cityElementToShow.push("district");
    cityElementToShow.push("ward");
  }
  return (
    <Container>
      <Row>
        <Col xs={12}>
          <h1>{t().settings__zone_management}</h1>
          <br />
        </Col>
      </Row>
      <Row>
        <Col xs={12} sm={8}>
          <FormGroup>
            <Select
              placeholder={t().zone_element__select_zone}
              options={zones}
              value={selectedZone?.zone ? selectedZone : null}
              onChange={onZoneSelectionChange}
            />
          </FormGroup>
        </Col>
        <Col xs={12} sm={4}>
          <FormGroup>
            <Button color="primary" onClick={toogleCreateZoneModal}>
              <i className="material-icons">add</i>
              <span>{t().action__create_new}</span>
            </Button>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          {showCreateZoneModal && (
            <CreateZoneModal
              mode={zoneModalMode}
              inputZone={selectedZone?.zone || {}}
              onSave={onZoneSave}
            />
          )}
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <ButtonGroup>
            <Button
              size="sm"
              color="primary"
              onClick={() => setDisplayTab("zone_settings")}
            >
              {t().zone_element__setting_zone}
            </Button>
            <Button
              size="sm"
              color="primary"
              onClick={() => setDisplayTab("zone_users")}
            >
              {t().zone_element__assign_user}
            </Button>
            {selectedZone?.zone && (
              <Button
                size="sm"
                color="secondary"
                onClick={() => {
                  setShowCreateZoneModal(true);
                  setZoneModalMode("edit");
                }}
              >
                {t().zone_element__edit_zone}
              </Button>
            )}
          </ButtonGroup>
        </Col>
      </Row>
      {selectedZone && selectedZone.value && displayTab === "zone_settings" && (
        <Fragment>
          <Row style={styles.section}>
            <Col xs={12}>
              <h4 style={styles.sectionTitle}>
                {t().zone_element__setting_zone}
              </h4>
            </Col>
            <Col xs={12}>
              <div>
                {t().zone_element__select_zone_element}{" "}
                {selectedZone?.zone?.name} ({selectedZone?.zone?.zone_level})
              </div>
              <div style={styles.cityPicker}>
                <CityPicker
                  onSelect={(selectedData) =>
                    setSelectedZoneElement(selectedData)
                  }
                  elementToShow={cityElementToShow}
                />
              </div>
            </Col>
            <Col xs={12}>
              <div style={styles.zoneSettingsControl}>
                <Button
                  color="primary"
                  onClick={addZoneElement}
                  style={styles.zoneSettingsButton}
                >
                  {t().action__add}
                </Button>{" "}
                <Button
                  color="success"
                  onClick={saveZoneElement}
                  style={styles.zoneSettingsButton}
                >
                  {t().action__save}
                </Button>
              </div>
            </Col>
          </Row>
          <Row style={styles.section}>
            <Col xs={12}>
              {zoneElements.map((zoneElement: any) => (
                <div key={`${zoneElement.id}`} style={styles.zoneElement}>
                  <span>{zoneElement.name}</span>
                  <span
                    onClick={() => removeZoneElement(zoneElement)}
                    style={styles.removeZoneElement}
                  >
                    X
                  </span>
                </div>
              ))}
            </Col>
          </Row>
        </Fragment>
      )}
      {selectedZone && selectedZone.value && displayTab === "zone_users" && (
        <Fragment>
          <Row style={styles.section}>
            <Col xs={12}>
              <h4 style={styles.sectionTitle}>
                {t().zone_element__setting_user}
              </h4>
            </Col>
            <Col xs={12}>
              <Label>
                {t().zone_element__assign_user_to_zone} {selectedZone.name}
              </Label>
              <Select
                isMulti
                options={users}
                value={userZoneAssignment}
                onChange={(selectedUsers) => addUserToZone(selectedUsers)}
              />
            </Col>
            <Col xs={12}>
              <Button
                color="success"
                onClick={saveZoneAssignment}
                style={styles.saveButton}
              >
                {t().action__save}
              </Button>
            </Col>
          </Row>
        </Fragment>
      )}
    </Container>
  );
}

const styles = {
  section: {
    marginTop: 48,
  },
  sectionTitle: {
    paddingBottom: 12,
    borderBottom: "1px solid var(--color-line)",
  },
  zoneSettingsControl: {
    display: "flex",
  },
  zoneSettingsButton: {
    marginRight: 12,
  },
  cityPicker: {
    marginTop: 12,
  },
  zoneElement: {
    padding: 6,
    backgroundColor: "var(--color-line)",
    marginBottom: 6,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  removeZoneElement: {
    width: 20,
    height: 20,
    borderRadius: 10,
    margin: 6,
    backgroundColor: "var(--danger)",
    color: "var(--color-white)",
    fontWeight: 700,
    fontSize: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  saveButton: {
    marginTop: 12,
  },
};
